<template>
  <div class="grid col-3 col-gap-2 sm-col-2 row-gap-1">
    <div class="card card-shadow user-result" v-for="lesson in filtered_items" :key="lesson.id" :class="{'tw-opacity-50': !isAvailable(lesson)}">
      <a :href="isAvailable(lesson) ? '/resources/' + lesson.product.slug + '/' + lesson.module.slug + '/' + lesson.slug : '#'">
        <div class="card-top top-image">
          <img :src="lesson.product.image">
          <div class="tw-absolute tw-top-0 tw-right-0 tw-p-4 tw-opacity-75 tw-text-gray-800" v-if="!isAvailable(lesson)">
            <i class="far fa-lock"></i>
          </div>
        </div>
      </a>
      <div class="card-inner">
        <a class="tw-text-gray-700 tw-font-semibold tw-text-base hover:tw-opacity-75" :href="isAvailable(lesson) ? '/resources/' + lesson.product.slug + '/' + lesson.module.slug + '/' + lesson.slug : '#'">{{ lesson.title }}</a>
        <span class="tw-text-gray-300 tw-text-xs tw-block tw-mt-2 tw-text-sm">in <a class="hover:tw-opacity-75" :href="isAvailable(lesson) ? '/resources/' + lesson.product.slug : '#'">{{ lesson.product.name }}</a></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SearchLesson',

  props: {
    items: {
      required: true,
    },
    extended: {
      required: true,
      default: false,
    },
  },

  computed: {
    filtered_items() {
      if(this.extended) {
        return this.items;
      }

      return this.items.slice(0, 3);
    },
  },

  methods: {
    isAvailable(lesson) {
      return lesson.product.available;
    }
  }
}
</script>

<style lang="scss" scoped>
.tw-text-gray-700 {
  color: #4a5568 !important;
}

.card {
  @apply tw-rounded-none tw-overflow-hidden #{!important};

  &.card-shadow {
    @apply tw-shadow #{!important};
  }
}
</style>